function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.27108 28.1204C6.83267 34.4128 6.29916 41.5085 8.17954 48.5262C12.8885 66.1002 30.9523 76.5293 48.5263 71.8204C56.2583 69.7486 62.6072 65.0917 66.8924 59.0288C72.347 51.3113 74.4577 41.3157 71.8205 31.4736C69.3035 22.08 62.9708 14.7276 54.9367 10.6374C47.9405 7.07558 39.654 5.98752 31.4738 8.17942C26.4289 9.53117 21.9729 11.9834 18.2947 15.2087",
  stroke: "#303641",
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M79.2458 44.219C80.1166 36.1809 78.5336 27.8037 74.1814 20.2654C63.2823 1.38755 39.1433 -5.08047 20.2654 5.81865C11.9598 10.6139 6.0564 17.972 2.97732 26.3173C-0.942047 36.94 -0.285165 49.1624 5.81871 59.7346C11.6445 69.8252 21.2532 76.3702 31.8192 78.6124C41.0203 80.565 50.9474 79.2546 59.7346 74.1813C65.1537 71.0526 69.5502 66.8328 72.8068 61.9597",
  stroke: "#303641",
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 47,
  width: 9,
  height: 24,
  rx: 4.5,
  transform: "rotate(-180 44 47)",
  fill: "#D3D3D5"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 60,
  width: 9,
  height: 9,
  rx: 4.5,
  transform: "rotate(-180 44 60)",
  fill: "#FF5951"
});
const SvgError = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error.3cf4e8bc.svg";
export { ForwardRef as ReactComponent };